import { Panel, PanelType } from 'office-ui-fabric-react';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Dialog, DialogFooter, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { DataAgence } from '../../data/DataAgence.jsx';
import { DataCompte } from '../../data/DataCompte.jsx';
import { DataRegion } from '../../data/DataRegion.jsx';
import { DataSociete } from '../../data/DataSociete.jsx';
import { MaxLengths } from '../../data/MaxLenghts.jsx';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxAgence } from '../ComboBox/ComboBoxAgence.jsx';
import { ComboBoxCivilite } from '../ComboBox/ComboBoxCivilite';
import { ComboBoxRegion } from '../ComboBox/ComboBoxRegion.jsx';
import { ComboBoxSociete } from '../ComboBox/ComboBoxSociete';
import { EUITextField } from '../EUI/EUITextField.jsx';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

/*
***************************************************************
 PROPS:
    loginCompte : string

    onAffichePanelCompte : bool

    onAnnuleFiche : méthode
    onEnregistrementFiche : méthode    
    creationCompteEiffage: bool => force la selection de la société sur eiffage
  
    classname : classe CSS (string)
    classnameinner : classe CSS (string)
***************************************************************
*/

var objetState = {

    //AF 03/12/2019
    optionsRegions: [],
    optionsAgences: [],

    compte: [],

    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',

    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: '',

    onAfficheDialogActivation: false,
    onAfficheDialogDesactivation: false,

    onActiveBoutonEnregistrer: false,

    //forceEnregistrement: false,

    societeRaisonSociale: ''
};

export class FicheCompte extends Component {

    _creationContent() {
        const titrePanel = this.props.loginCompte ? 'Edition du compte' : 'Création de compte';
        const { creationCompteEiffage } = this.props;

        return (
            <Panel
                closeButtonAriaLabel="Fermer"
                headerText={titrePanel}
                isOpen={this.props.onAffichePanelCompte}
                onDismiss={this._onAnnulation} // KP (28/09/2020) : ligne décommentée (cause panel se réouvre à sa fermeture) ; à surveiller/re-commenter ?
                onOpen={this._onOpen}
                onRenderFooterContent={this._onRenderFooterContent}
                type={PanelType.medium}
            >
                <div className={this.props.classname}>
                    <div className={this.props.classnameinner}>
                        <div className="ms-Grid" dir="ltr">

                            <MessageBars
                                errorMessage={this.state.errorMessage}
                                warningMessage={this.state.warningMessage}
                                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                            />

                            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12 ms-lg6">

                                    <ComboBoxSociete
                                        disabled={creationCompteEiffage}
                                        doitInclureSocietesSansCompte
                                        doitInclureSocietesSansMandat
                                        onChange={(event, option, index, value, item) => this._onChangeSociete(item.idSociete)}
                                        required
                                        selectedKey={creationCompteEiffage ? 1 : this.state.compte.idSociete}
                                    />
                                </div>
                                <div className="ms-Grid-col ms-sm12 ms-lg6">
                                    <EUITextField
                                        disabled
                                        label="Raison sociale"
                                        maxLength={MaxLengths.societe.raisonSociale}
                                        value={this.state.societeRaisonSociale}
                                    />
                                </div>
                            </div>
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12 ms-lg6">
                                    <ComboBoxCivilite
                                        onChange={(event, option, index, value, item) => Scriba.state().setObjetPropriete(this, "compte", "civilite", option.key)}
                                        required
                                        selectedKey={this.state.compte.civilite}
                                    />
                                </div>
                                <div className="ms-Grid-col ms-sm12 ms-lg6">
                                    <EUITextField
                                        label="Nom"
                                        maxLength={MaxLengths.compte.nom}
                                        onDelayedChange={(event, newValue) => this._onRenseignementLoginCompte(null, newValue)}
                                        required
                                        value={this.state.compte.nom}
                                    />
                                </div>
                            </div>
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12 ms-lg6">
                                    <EUITextField
                                        label="Prénom"
                                        maxLength={MaxLengths.compte.prenom}
                                        onDelayedChange={(event, newValue) => this._onRenseignementLoginCompte(newValue, null)}
                                        required
                                        value={this.state.compte.prenom}
                                    />
                                </div>
                                <div className="ms-Grid-col ms-sm12 ms-lg6">
                                    <EUITextField
                                        label="Téléphone"
                                        maxLength={MaxLengths.compte.tel}
                                        onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "compte", "tel", newValue, this._onVerificationFormulaire)}
                                        required
                                        value={this.state.compte.tel}
                                    />
                                </div>
                            </div>
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12 ms-lg6">
                                    <EUITextField
                                        label="Mobile"
                                        maxLength={MaxLengths.compte.mobile}
                                        onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "compte", "mobile", newValue, this._onVerificationFormulaire)}
                                        value={this.state.compte.mobile}
                                    />
                                </div>
                                <div className="ms-Grid-col ms-sm12 ms-lg6">
                                    <EUITextField
                                        label="Fax"
                                        maxLength={MaxLengths.compte.fax}
                                        onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "compte", "fax", newValue, this._onVerificationFormulaire)}
                                        value={this.state.compte.fax}
                                    />
                                </div>
                            </div>
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12 ms-lg6">
                                    <EUITextField
                                        label="Email"
                                        maxLength={MaxLengths.compte.email}
                                        onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "compte", "email", newValue, this._onVerificationFormulaire)}
                                        required
                                        value={this.state.compte.email}
                                    />
                                </div>
                                <div className="ms-Grid-col ms-sm12 ms-lg6"></div>
                            </div>

                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12 ms-lg6">
                                    <EUITextField
                                        label="Adresse"
                                        maxLength={MaxLengths.compte.adresse}
                                        multiline
                                        onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "compte", "adresse", newValue, this._onVerificationFormulaire)}
                                        value={this.state.compte.adresse}
                                        required
                                        rows={3}
                                    />
                                </div>
                                <div className="ms-Grid-col ms-sm12 ms-lg6">
                                    <EUITextField
                                        label="Compl. d'adresse"
                                        maxLength={MaxLengths.compte.complementAdresse}
                                        multiline
                                        onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "compte", "complementAdresse", newValue, this._onVerificationFormulaire)}
                                        value={this.state.compte.complementAdresse}
                                        required
                                        rows={3}
                                    />
                                </div>
                            </div>
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12 ms-lg6">
                                    <EUITextField
                                        label="CP"
                                        maxLength={MaxLengths.compte.cp}
                                        onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "compte", "cp", newValue, this._onVerificationFormulaire)}
                                        required
                                        value={this.state.compte.cp}
                                    />
                                </div>
                                <div className="ms-Grid-col ms-sm12 ms-lg6">
                                    <EUITextField
                                        label="Ville"
                                        maxLength={MaxLengths.compte.ville}
                                        onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "compte", "ville", newValue, this._onVerificationFormulaire)}
                                        required
                                        value={this.state.compte.ville}
                                    />
                                </div>
                            </div>

                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12 ms-lg6">
                                    <EUITextField
                                        disabled
                                        label="Login"
                                        value={this.state.compte.loginCompte}
                                    />
                                </div>
                                <div className="ms-Grid-col ms-sm12 ms-lg6"></div>
                            </div>

                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12 ms-lg6">
                                    <ComboBoxRegion
                                        onChange={(event, option) => this._onChangeRegion(option.key)}
                                        selectedKey={this.state.compte.idRegion}
                                    />
                                </div>
                                <div className="ms-Grid-col ms-sm12 ms-lg6">
                                    <ComboBoxAgence
                                        idRegion={this.state.compte.idRegion}
                                        onChange={(event, option) => Scriba.state().setObjetPropriete(this, "compte", "idAgence", option.key, this._onVerificationFormulaire)}
                                        selectedKey={this.state.compte.idAgence}
                                    />
                                </div>
                            </div>
                        </div>

                        <Dialog
                            hidden={!this.state.onAfficheDialogActivation}
                            onDismiss={this._onCacheDialogActivation}
                            dialogContentProps={{
                                type: DialogType.normal,
                                title: 'Activation du compte',
                                subText: `Attention, confirmez-vous l'activation du compte de ${this.state.compte.prenom} ${this.state.compte.nom} ?`
                            }}
                            modalProps={{
                                isBlocking: true,
                                styles: { main: { maxWidth: 450 } }
                            }}
                        >
                            <DialogFooter>
                                <PrimaryButton onClick={() => this._onToggleActivation(true)} text="Activer" />
                                <DefaultButton onClick={() => this._onCacheDialogActivation()} text="Annuler" />
                            </DialogFooter>
                        </Dialog>

                        <Dialog
                            hidden={!this.state.onAfficheDialogDesactivation}
                            onDismiss={this._onCacheDialogDesactivation}
                            dialogContentProps={{
                                type: DialogType.normal,
                                title: 'Désactivation du compte',
                                subText: `Attention, confirmez-vous la désactivation du compte de ${this.state.compte.prenom} ${this.state.compte.nom} ?`
                            }}
                            modalProps={{
                                isBlocking: true,
                                styles: { main: { maxWidth: 450 } }
                            }}
                        >
                            <DialogFooter>
                                <PrimaryButton onClick={() => this._onToggleActivation(false)} text="Désactiver" />
                                <DefaultButton onClick={() => this._onCacheDialogDesactivation()} text="Annuler" />
                            </DialogFooter>
                        </Dialog>
                    </div>
                </div>
            </Panel>
        );
    }

    constructor(props) {
        super(props);

        this.state = objetState;
    }

    _onInit() {
        this.setState(
            objetState
        );
    }

    _onEnregistrement = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement du compte en cours'
        });

        var enregistrementCompte = DataCompte._onEnregistrementCompte(this.state.compte, this.props.loginCompte);

        enregistrementCompte
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });

                    this.props.onEnregistrementFiche();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onAfficheDialogActivation() {
        this.setState({
            onAfficheDialogActivation: true,
            onAfficheDialogDesactivation: false
        })
    }

    _onCacheDialogActivation() {
        this.setState({
            onAfficheDialogActivation: false,
            onAfficheDialogDesactivation: false
        })
    }

    _onAfficheDialogDesactivation() {
        this.setState({
            onAfficheDialogActivation: false,
            onAfficheDialogDesactivation: true
        })
    }

    _onCacheDialogDesactivation() {

        this.setState({
            onAfficheDialogActivation: false,
            onAfficheDialogDesactivation: false
        })
    }


    _onChangeSociete = (idSociete) => {
        Scriba.state().setObjetPropriete(this, "compte", "idSociete", idSociete);
        Immocom.fiche()._validationFormulaire(this, 'Compte', this.state.compte, (this.props.loginCompte !== null ? 'Modification' : 'Création'));

        var chargementSociete = DataSociete._chargementSociete(idSociete);

        chargementSociete
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let societe = responseFetch.reponseAPIobjet;

                    let stateTemp = {};
                    stateTemp.societeRaisonSociale = societe.raisonSociale;

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }
    _onRenseignementLoginCompte = (prenom, nom) => {

        if (prenom) {
            Scriba.state().setObjetPropriete(this, "compte", "prenom", prenom, this._onVerificationFormulaire);
            nom = (this.state.compte.nom !== undefined || this.state.compte.nom !== '' ? this.state.compte.nom : nom);
        }
        else if (nom) {
            prenom = (this.state.compte.prenom !== undefined && this.state.compte.prenom !== '' ? this.state.compte.prenom : prenom);
            Scriba.state().setObjetPropriete(this, "compte", "nom", nom, this._onVerificationFormulaire);
        }

        if ((this.state.loginCompte === '' || this.state.loginCompte === undefined) && (prenom !== null && nom !== null)) {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: 'Génération du login en cours'
            });

            var renseignementLoginCompte = DataCompte._onRenseignementLoginCompte(prenom, nom);

            renseignementLoginCompte
                .then(responseFetch => {
                    let loginCompte = responseFetch.reponseAPIobjet;

                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        let compteTemp = { ...this.state.compte };
                        compteTemp.loginCompte = loginCompte;

                        let stateTemp = {};
                        stateTemp.compte = compteTemp;

                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
        }
    }

    _onChangeRegion = (idRegion) => {
        const compte = { ...this.state.compte, idRegion, idAgence: 0 };
        this.setState({ compte }, this._onVerificationFormulaire);
    };

    _onVerificationFormulaire() {
        Immocom.fiche()._validationFormulaire(this, 'Compte', this.state.compte, (this.props.loginCompte !== null ? 'Modification' : 'Création'));
    }

    _onToggleActivation = (estActif) => {
        let compte = { ...this.state.compte };
        compte.actif = estActif;

        this.setState(
            {
                compte,
                onAfficheDialogActivation: false,
                onAfficheDialogDesactivation: false
            },
            this._onEnregistrement // Enregistrement effectué une fois le setState terminé
        );
    }

    _onRegenereMotDePasse = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Regénération du mot de passe en cours'
        });

        var regenereMotDePasse = DataCompte._onRegenereMotDePasse(this.props.loginCompte);

        regenereMotDePasse
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });

                    this.props.onEnregistrementFiche();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onAbonnementNotification = () => {
        //addSubscribeUserToPush();
    }

    _onOpen = () => {
        const loginCompteRenseigne = Immocom.getSiPropsRenseignee(this.props.loginCompte);

        if (loginCompteRenseigne) this._chargementFicheCompteEnModeModification();
        else this._chargementFicheCompteEnModeCreation();
    };

    _onAnnulation = () => {
        this._onInit();
        this.props.onAnnuleFiche();
    }

    _chargementFicheCompteEnModeCreation() {
        this.setState({
            enCoursDeTraitement: true
        });

        var chargementRegion = DataRegion._chargementRegionPerimetreEiffage(false);

        chargementRegion
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let compteTemp = { ...this.state.compte };
                    compteTemp.idRegion = 0;
                    compteTemp.idAgence = 0;
                    compteTemp.loginCompte = '';

                    //AF - Ticket 1048 - On force l'idsociété pour les comptes Eiffage
                    if (this.props.creationCompteEiffage) {
                        compteTemp.idSociete = 1;
                    }

                    let stateTemp = {};
                    stateTemp.compte = compteTemp;

                    Immocom.onChargementOptions(responseFetch, this, stateTemp, 'optionsRegions', 'idRegion', 'region', true);

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);

                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _chargementFicheCompteEnModeModification() {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement du compte'
        });

        var chargementCompte = DataCompte._chargementFicheCompte(this.props.loginCompte);

        chargementCompte
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let itemCompte = responseFetch.reponseAPIobjet;

                    //On charge la raison sociale de la société
                    this._onChangeSociete(itemCompte[0].idSociete);

                    let listeDesPromisesAExecuter = [];

                    let stateTemp = {};

                    stateTemp.compte = itemCompte[0];

                    stateTemp.enCoursDeTraitement = false;
                    stateTemp.messageEnCoursTraitement = '';
                    stateTemp.hideMessageBarWarning = true;
                    stateTemp.warningMessage = '';
                    stateTemp.hideMessageBarError = true;
                    stateTemp.errorMessage = '';

                    Immocom.onReinitStateValeurParDefaut(stateTemp);

                    let chargementRegion = DataRegion._chargementRegionPerimetreEiffage(false);
                    listeDesPromisesAExecuter.push(chargementRegion.then(responseFetch => {
                        Immocom.onChargementOptions(responseFetch, this, stateTemp, 'optionsRegions', 'idRegion', 'region', true);
                    })
                    );

                    let chargementAgence = DataAgence._chargementAgencePerimetreEiffage(itemCompte[0].idRegion, false);
                    listeDesPromisesAExecuter.push(chargementAgence.then(responseFetch => {
                        Immocom.onChargementOptions(responseFetch, this, stateTemp, 'optionsAgences', 'idAgence', 'agence', true);
                    })
                    );

                    Promise.all(listeDesPromisesAExecuter).then(() => { this.setState(stateTemp, this._onVerificationFormulaire); });

                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onRenderFooterContent = () => {
        let disabledButton = !this.state.onActiveBoutonEnregistrer;
        let modeCreation = (this.props.loginCompte === '');
        let contenuButtonActivationDesactivation = null;

        /*YD : 03/07/2020 */
        /* rustine en attendant de l'implémenter complètement */
        let onAfficheNotification = (this.props.loginCompte === 'ImmocomGestNat');

        if (!modeCreation) {
            if (!this.state.compte.actif) {
                contenuButtonActivationDesactivation = <PrimaryButton onClick={() => this._onAfficheDialogActivation()} className="marginRight8px">Activer</PrimaryButton>;
            }
            else if (this.props.loginCompte !== sessionStorage.getItem('loginCompte')) { //On ne peut pas se désactiver
                contenuButtonActivationDesactivation = <PrimaryButton onClick={() => this._onAfficheDialogDesactivation()} className="marginRight8px">Désactiver</PrimaryButton>
            }

        }

        return (
            <div>
                <PrimaryButton onClick={() => this._onEnregistrement()} className="marginRight8px" disabled={disabledButton}>Enregistrer</PrimaryButton>
                {contenuButtonActivationDesactivation}
                <DefaultButton onClick={() => this._onRegenereMotDePasse()} className="marginRight8px" disabled={modeCreation}>Regénérer MDP</DefaultButton>

                {(onAfficheNotification ?
                    <DefaultButton onClick={() => this._onAbonnementNotification()} className="marginRight8px" disabled={modeCreation}>Notification</DefaultButton>
                    :
                    null)}

                <DefaultButton onClick={() => this._onAnnulation()}>Annuler</DefaultButton>
            </div>
        );
    };

    componentDidMount() { }

    componentDidUpdate() { }

    componentWillUnmount() { }

    render() {
        return this._creationContent();
    }
}
